export const FETCH_ORDERING_PREFERENCES_REQUESTED = 'FETCH_ORDERING_PREFERENCES_REQUESTED'
export const FETCH_ORDERING_PREFERENCES_SUCCEEDED = 'FETCH_ORDERING_PREFERENCES_SUCCEEDED'
export const FETCH_ORDERING_PREFERENCES_FAILED = 'FETCH_ORDERING_PREFERENCES_FAILED'
export const CREATE_CUSTOMER_ORDERING_PREFERENCES_REQUESTED = 'CREATE_CUSTOMER_ORDERING_PREFERENCES_REQUESTED'
export const CREATE_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED = 'CREATE_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED'
export const CREATE_CUSTOMER_ORDERING_PREFERENCES_FAILED = 'CREATE_CUSTOMER_ORDERING_PREFERENCES_FAILED'

export const fetchOrderingPreferences = () => ({
  type: FETCH_ORDERING_PREFERENCES_REQUESTED,
})

export const fetchOrderingPreferencesSucceeded = (payload) => ({
  type: FETCH_ORDERING_PREFERENCES_SUCCEEDED,
  payload,
})

export const fetchOrderingPreferencesFailed = (payload) => ({
  type: FETCH_ORDERING_PREFERENCES_FAILED,
  payload,
})

export const createCustomerOrderingPreferencesRequested = (payload) => ({
  type: CREATE_CUSTOMER_ORDERING_PREFERENCES_REQUESTED,
  payload,
})

export const createCustomerOrderingPreferencesSucceeded = (payload) => ({
  type: CREATE_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED,
  payload
})

export const createCustomerOrderingPreferencesFailed = () => ({
  type: CREATE_CUSTOMER_ORDERING_PREFERENCES_FAILED,
})
